import Config from '../../../utility/Config';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

export const timeDiffCalc = (dateFuture, dateNow) => {
  let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;
  // calculate days
  const days = Math.floor(diffInMilliSeconds / 86400);
  diffInMilliSeconds -= days * 86400;
  // console.log('calculated days', days);
  // calculate hours
  const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
  // console.log('calculated', hours);
  diffInMilliSeconds -= hours * 3600;
  // console.log('calculated hours', hours);
  // calculate minutes
  const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
  diffInMilliSeconds -= minutes * 60;
  // console.log('minutes', minutes);
  let difference = '';
  let differencee = '';
  if (days > 0) {
    difference += days === 1 ? `${days} day ` : `${days} days `;
  }
  difference += hours === 0 || hours === 1 ? `${hours} hour ` : `${hours} hours `;
  // differencee += dateFuture.diff(dateNow, hours)
  // difference += differencee % 24;
  difference += minutes === 0 || hours === 1 ? `${minutes} minutes` : `${minutes} minutes`;
  return difference;
};

export const getFields = (list, field) => {
  return list.reduce(function (carry, item) {
    if (typeof item === 'object' && field in item) {
      carry.push(item[field]);
    }
    return carry;
  }, []);
};

export const checkDateBetween = (dateFrom, dateTo, dateCheckStart) => {
  var d1 = dateFrom.split('/');
  var d2 = dateTo.split('/');
  var c = dateCheckStart.split('/');
  var from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]); // -1 because months are from 0 to 11
  var to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0]);
  var checkStart = new Date(c[2], parseInt(c[1]) - 1, c[0]);
  var isStartDateValid = checkStart >= from && checkStart <= to;
  return isStartDateValid;
};

export const isFromBiggerThanTo = (dtmfrom, dtmto) => {
  return new Date(dtmfrom).getTime() <= new Date(dtmto).getTime();
};
export const checkPastDate = (todayDate, pastDate) => {
  if (todayDate.isBefore(pastDate)) {
    return true;
  } else {
    return false;
  }
};

// deep link
export const ditectMobile = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};
export const goDeepLinking = url => {
  let fullUrl = Config.BaseURL.replace('https', Config.appProtocol);
  fullUrl = fullUrl + url;
  var app = {
    launchApp: function () {
      window.location.replace(fullUrl);
      this.timer = setTimeout(this.openWebApp, 100);
    },

    openWebApp: function () {
      //window.location.reload();
    },
  };
  if (ditectMobile()) {
    app.launchApp();
  }
};
export const setApiMessage = (type, message) => {
  // return () => {
  switch (type) {
    case 'info':
      NotificationManager.info(message);
      break;
    case 'success':
      NotificationManager.success(message);
      break;
    case 'warning':
      NotificationManager.warning(message);
      break;
    case 'error':
      NotificationManager.error(message);
      break;
  }
  // };
};
// var today = moment();
//     var endDate = moment(Event.endDate);
//     var totalDays = 0;
//     var totalHours = 0;
//     var clearHours = 0;
//     var totalMinutes = 0;
//     var clearMinutes = 0;
//     if (Event.endDate !== null) {
//       totalDays = endDate.diff(today, 'days');
//       totalHours = endDate.diff(today, 'hours');
//       clearHours = totalHours % 24;
//       totalMinutes = endDate.diff(today, 'minutes');
//       clearMinutes = totalMinutes % 60;
//     }

export const getAppLinkByMobileOS = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) {
    return 'https://play.google.com/store/apps/details?id=au.com.oktion';
  } else if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return 'https://apps.apple.com/au/app/oktion/id1437126868';
  }
  return '';
};
